import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { GetAllUser } from '../services/userservice';

function UserList() {
    const [data, setData] = useState([]);
    const location = useLocation();
    const { successMessage } = location.state || {};
    let navigate = useNavigate();

    useEffect(() => {
        const response = fillData();
        toast(successMessage);
    }, []);

    const fillData = async () => {
        try {
            const userList = await GetAllUser();
            const jsonUserList = JSON.parse(userList);
            setData(jsonUserList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const handleDelete = async (mediaId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this media?");
        if (isConfirmed) {
            //DeletePost(mediaId);
            const response = await fillData();
            toast("Media deleted successfully!");
        }
    };

    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <p class="card-title mb-0">Users</p>
                                </div>
                                <div class="col-md-6 right-align">
                                    <Link to="/user/add" className='nav-link'>
                                        <button type="submit" class="btn btn-primary me-2">New User</button>
                                    </Link>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr>
                                            <th>PK</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Username</th>
                                            <th>User Type</th>
                                            <th>Photo</th>
                                            <th>Added On</th>
                                            <th>Updated On</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data?.map((item) => (
                                                <tr>
                                                    <td>{item.pk}</td>
                                                    <td class="font-weight-bold">{item.firstname}</td>
                                                    <td>{item.lastname}</td>
                                                    <td>{item.username}</td>
                                                    <td>{item.usertype}</td>
                                                    <td> {item.photourl}</td>
                                                    <td>{item.addedon}</td>
                                                    <td>{item.updatedon}</td>
                                                    <td>
                                                        <i
                                                            className="mdi mdi-delete mdi-big font20 pointer"
                                                            title="Delete Record"
                                                            onClick={() => handleDelete(item.pk)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default UserList;
